/**
 * Bilingual Translations (Hebrew / English)
 * ==========================================
 * Full translation support for the M'art Microlit Guide Module
 */

export const translations = {
  he: {
    // Navigation & Header
    backToSite: 'חזרה לאתר',
    sharePage: 'שתף עמוד',
    language: 'EN',
    
    // Hero Section
    heroTitle: 'הדרכה מהירה',
    heroSubtitle: 'Microlit Mineral Coating',
    heroDescription: 'יישום גמר מינרלי מוכן לשימוש בפרוייקטים אישיים/תעשייתיים על פני יציקות, הדפסות תלת מימד, קלקר, חימר, בטון ועוד מגוון רחב של תשתיות',
    
    // Section titles
    surfaceTitle: 'בחר משטח',
    surfaceSubtitle: 'Choose Surface Type',
    surfaceDescription: 'בחר את סוג המשטח עליו תרצה למרוח את הציפוי המינרלי',
    
    sizeTitle: 'בחר גודל יצירה',
    sizeSubtitle: 'Choose Creation Size',
    sizeDescription: 'בחר גודל מוכן או הזן מידה מותאמת אישית',
    
    colorTitle: 'בחר גוון',
    colorSubtitle: 'Choose Color',
    colorDescription: 'בחר את הגוון המועדף עליך מתוך מגוון הצבעים של Microlit',
    
    textureTitle: 'בחר סוג גימור',
    textureSubtitle: 'Choose Finish Type',
    textureDescription: 'האם אתה רוצה גימור חלק או טקסטורה?',
    
    sealerTitle: 'הוספת סילר?',
    sealerSubtitle: 'Add Sealer?',
    sealerDescription: 'סילר מגן מפני מים ולכלוך - מומלץ לשימוש חיצוני',
    
    // Options
    textureSmooth: 'גימור חלק',
    textureTextured: 'טקסטורה',
    yes: 'כן',
    no: 'לא',
    
    // Area
    areaTitle: 'שטח',
    areaUnit: 'מ"ר',
    areaCmUnit: 'סמ"ר',
    customSize: 'מידה מותאמת אישית',
    length: 'אורך',
    width: 'רוחב',
    cm: 'ס"מ',
    
    // Primers
    primerSolan: 'פריימר סולן',
    primerQuartz: 'פריימר קוורץ',
    primerSolanDesc: 'לתשתית סופגת',
    primerQuartzDesc: 'לתשתית לא סופגת',
    
    // Calculator
    calculatorTitle: 'תוצאות חישוב',
    totalRequired: 'סה"כ נדרש',
    packagingBreakdown: 'פירוט אריזות',
    packsNeeded: 'אריזות נדרשות',
    leftover: 'עודף משוער',
    recommended: 'מומלץ',
    
    // Application Guide
    guideTitle: 'מדריך יישום',
    guideSubtitle: 'Application Guide',
    guideDescription: 'עקוב אחר השלבים לקבלת תוצאות מקצועיות',
    duration: 'משך',
    tips: 'טיפים',
    criticalNote: 'חשוב!',
    optional: 'אופציונלי',
    
    // Summary
    summaryTitle: 'סיכום הזמנה',
    summarySubtitle: 'Order Summary',
    selectedSurface: 'משטח שנבחר',
    selectedColor: 'גוון שנבחר',
    selectedSize: 'גודל שנבחר',
    finishType: 'סוג גימור',
    withSealer: 'עם סילר',
    withoutSealer: 'ללא סילר',
    primerType: 'סוג פריימר',
    quantities: 'כמויות',
    packaging: 'אריזות',
    
    // Actions
    copySummary: 'העתק סיכום',
    printSummary: 'הדפס',
    shareWhatsApp: 'שתף בוואטסאפ',
    contactUs: 'צור קשר',
    startOver: 'התחל מחדש',
    
    // Warnings
    warningTitle: 'שים לב',
    
    // Footer
    footerCompany: 'שחל - חומרי בניין',
    footerTagline: 'טכנולוגיות מינרליות ופולימריות חדשניות מאז 1958',
    questionsContact: 'שאלות? צור קשר בוואטסאפ:',
    
    // Misc
    copied: 'הועתק!',
    loading: 'טוען...',
    error: 'שגיאה',
    success: 'הצלחה',
  },
  
  en: {
    // Navigation & Header
    backToSite: 'Back to Site',
    sharePage: 'Share Page',
    language: 'עב',
    
    // Hero Section
    heroTitle: 'Quick Guide',
    heroSubtitle: 'Microlit Mineral Coating',
    heroDescription: 'Ready-to-use mineral finish for personal/industrial projects on casts, 3D prints, foam, clay, concrete and a wide variety of substrates',
    
    // Section titles
    surfaceTitle: 'Choose Surface',
    surfaceSubtitle: 'בחר משטח',
    surfaceDescription: 'Select the surface type you want to coat with mineral finish',
    
    sizeTitle: 'Choose Creation Size',
    sizeSubtitle: 'בחר גודל',
    sizeDescription: 'Select a preset size or enter custom dimensions',
    
    colorTitle: 'Choose Color',
    colorSubtitle: 'בחר גוון',
    colorDescription: 'Select your preferred color from Microlit\'s range',
    
    textureTitle: 'Choose Finish Type',
    textureSubtitle: 'בחר סוג גימור',
    textureDescription: 'Do you want a smooth or textured finish?',
    
    sealerTitle: 'Add Sealer?',
    sealerSubtitle: 'הוספת סילר?',
    sealerDescription: 'Sealer protects from water and dirt - recommended for outdoor use',
    
    // Options
    textureSmooth: 'Smooth Finish',
    textureTextured: 'Textured Finish',
    yes: 'Yes',
    no: 'No',
    
    // Area
    areaTitle: 'Area',
    areaUnit: 'm²',
    areaCmUnit: 'cm²',
    customSize: 'Custom Size',
    length: 'Length',
    width: 'Width',
    cm: 'cm',
    
    // Primers
    primerSolan: 'Primer Solan',
    primerQuartz: 'Primer Quartz',
    primerSolanDesc: 'For absorbent substrates',
    primerQuartzDesc: 'For non-absorbent substrates',
    
    // Calculator
    calculatorTitle: 'Calculator Results',
    totalRequired: 'Total Required',
    packagingBreakdown: 'Packaging Breakdown',
    packsNeeded: 'Packs Needed',
    leftover: 'Estimated Leftover',
    recommended: 'Recommended',
    
    // Application Guide
    guideTitle: 'Application Guide',
    guideSubtitle: 'מדריך יישום',
    guideDescription: 'Follow the steps for professional results',
    duration: 'Duration',
    tips: 'Tips',
    criticalNote: 'Important!',
    optional: 'Optional',
    
    // Summary
    summaryTitle: 'Order Summary',
    summarySubtitle: 'סיכום הזמנה',
    selectedSurface: 'Selected Surface',
    selectedColor: 'Selected Color',
    selectedSize: 'Selected Size',
    finishType: 'Finish Type',
    withSealer: 'With Sealer',
    withoutSealer: 'Without Sealer',
    primerType: 'Primer Type',
    quantities: 'Quantities',
    packaging: 'Packaging',
    
    // Actions
    copySummary: 'Copy Summary',
    printSummary: 'Print',
    shareWhatsApp: 'Share on WhatsApp',
    contactUs: 'Contact Us',
    startOver: 'Start Over',
    
    // Warnings
    warningTitle: 'Note',
    
    // Footer
    footerCompany: 'Shahal Building Materials',
    footerTagline: 'Innovative mineral and polymer technologies since 1958',
    questionsContact: 'Questions? Contact us on WhatsApp:',
    
    // Misc
    copied: 'Copied!',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
  },
};

export const getTranslation = (lang, key) => {
  const keys = key.split('.');
  let value = translations[lang];
  for (const k of keys) {
    value = value?.[k];
  }
  return value || key;
};
